export default __webpack_public_path__ + "0555f93dc80b5749194a08e252a05f7a.png";